import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Capture invite event ID before Supabase auth clears the URL
const params = new URLSearchParams(window.location.search);
const eventId = params.get('event');
if (eventId) sessionStorage.setItem('inviteEventId', eventId);

// Capture password reset before Supabase auth clears the hash
const hashParams = new URLSearchParams(window.location.hash.slice(1));
const hashType = hashParams.get('type');
if (hashType === 'recovery') sessionStorage.setItem('authType', 'recovery');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);